import React from 'react';
import { withAllContexts } from '../../AllContextsWrapper';
import { X, Trash2, Plus, Settings, DollarSign, Users } from 'lucide-react';

import { enqueueSnackbar } from 'notistack';

class AdminModal extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            tab: 0,
            calendars: [],
            users: [],
            selectedUser: null,
            userAccess: [],

            // New Calendar Form
            newCalendarName: '',
            newCalendarType: 'rafting',

            // Assign Access Form
            assignCalendarId: '',

            // Plugins
            selectedCalendarPlugins: null,
            plugins: [],

            // Pricing Settings
            selectedCalendarSettings: null,
            pricingSettings: {
                price_1day_workday: 20,
                price_1day_weekend: 25,
                price_multiday_workday: 17,
                price_multiday_weekend: 18
            },

            error: null
        };
    }

    componentDidMount() {
        if (this.props.socketIO.user?.id === 1) {
            this.fetchData();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.app.state.shownComponent && this.props.app.state.shownComponent === 'admin') {
            this.fetchData();
        }
    }

    fetchData = () => {
        this.fetchCalendars();
        this.fetchUsers();
    }

    fetchCalendars = () => {
        this.props.socketIO.socket.emit('calendars:getAllAdmin', (response) => {
            if (response.success) {
                this.setState({ calendars: response.data });
            }
        });
    }

    fetchUsers = () => {
        this.props.socketIO.socket.emit('user:get_all', (response) => {
            if (response.success) {
                this.setState({ users: response.data });
            }
        });
    }

    createCalendar = () => {
        const { newCalendarName, newCalendarType } = this.state;
        if (!newCalendarName) return;

        this.props.socketIO.socket.emit('calendars:create', {
            name: newCalendarName,
            type: newCalendarType,
            settings: "{}"
        }, (response) => {
            if (response.success) {
                this.setState({ newCalendarName: '' });
                this.fetchCalendars();
                enqueueSnackbar("Kalendár bol vytvorený", { variant: 'success' });
            } else {
                enqueueSnackbar("Chyba pri vytváraní kalendára: " + (response.error || response.err || 'Neznáma chyba'), { variant: 'error' });
            }
        });
    }

    deleteCalendar = (id) => {
        if (!window.confirm("Naozaj zmazať kalendár?")) return;
        this.props.socketIO.socket.emit('calendars:delete', id, (response) => {
            if (response.success) {
                this.fetchCalendars();
                enqueueSnackbar("Kalendár bol zmazaný", { variant: 'success' });
            } else {
                enqueueSnackbar("Chyba pri mazaní kalendára: " + (response.error || response.err || 'Neznáma chyba'), { variant: 'error' });
            }
        });
    }

    createUser = () => {
        const { newUser } = this.state;
        if (!newUser || !newUser.name || !newUser.email || !newUser.password || !newUser.short_name) {
            enqueueSnackbar("Vyplňte všetky povinné polia (Meno, Skratka, Email, Heslo)", { variant: 'warning' });
            return;
        }

        this.props.socketIO.socket.emit('user:create', newUser, (response) => {
            if (response.success) {
                this.setState({ isCreatingUser: false, newUser: null });
                this.fetchUsers();
                this.selectUser(response.data);
                enqueueSnackbar("Používateľ bol úspešne vytvorený", { variant: 'success' });
            } else {
                enqueueSnackbar("Chyba pri vytváraní používateľa: " + (response.error || response.err || 'Neznáma chyba'), { variant: 'error' });
            }
        });
    }

    deleteUser = (id) => {
        if (!window.confirm("Naozaj chcete natrvalo zmazať tohto používateľa? Táto akcia je nevratná.")) return;
        this.props.socketIO.socket.emit('user:delete', id, (response) => {
            if (response.success) {
                this.setState({ selectedUser: null });
                this.fetchUsers();
                enqueueSnackbar("Používateľ bol zmazaný", { variant: 'success' });
            } else {
                enqueueSnackbar("Chyba pri mazaní používateľa: " + (response.error || response.err || 'Neznáma chyba'), { variant: 'error' });
            }
        });
    }

    adminChangePassword = () => {
        const { selectedUser, resetPassword } = this.state;
        if (!selectedUser || !resetPassword) return;

        this.props.socketIO.socket.emit('user:admin_change_password', {
            userId: selectedUser.id,
            newPassword: resetPassword
        }, (response) => {
            if (response.success) {
                enqueueSnackbar("Heslo bolo úspešne zmenené", { variant: 'success' });
                this.setState({ resetPassword: '' });
            } else {
                enqueueSnackbar("Chyba pri zmene hesla: " + (response.error || response.err || 'Neznáma chyba'), { variant: 'error' });
            }
        });
    }

    selectUser = (user) => {
        this.setState({ selectedUser: user, userAccess: [], isCreatingUser: false, resetPassword: '' });
        this.props.socketIO.socket.emit('user:get_access', user.id, (response) => {
            if (response.success) {
                this.setState({ userAccess: response.data });
            }
        });
    }

    grantAccess = () => {
        const { selectedUser, assignCalendarId } = this.state;
        if (!selectedUser || !assignCalendarId) return;

        this.props.socketIO.socket.emit('user:grant_access', {
            userId: selectedUser.id,
            calendarId: assignCalendarId,
            role: 'user'
        }, (response) => {
            if (response.success) {
                this.selectUser(selectedUser); // refresh
                enqueueSnackbar("Prístup pridelený", { variant: 'success' });
            } else {
                enqueueSnackbar("Chyba pri prideľovaní prístupu: " + (response.error || response.err || 'Neznáma chyba'), { variant: 'error' });
            }
        });
    }

    revokeAccess = (calendarId) => {
        const { selectedUser } = this.state;
        if (!selectedUser) return;

        this.props.socketIO.socket.emit('user:revoke_access', {
            userId: selectedUser.id,
            calendarId: calendarId
        }, (response) => {
            if (response.success) {
                this.selectUser(selectedUser); // refresh
                enqueueSnackbar("Prístup odobraný", { variant: 'success' });
            } else {
                enqueueSnackbar("Chyba pri odoberaní prístupu: " + (response.error || response.err || 'Neznáma chyba'), { variant: 'error' });
            }
        });
    }

    openPlugins = (calendar) => {
        this.setState({ selectedCalendarPlugins: calendar, plugins: [] });
        this.props.socketIO.socket.emit('calendars:getPlugins', calendar.id, (response) => {
            if (response.success) {
                this.setState({ plugins: response.data });
            }
        });
    }

    closePlugins = () => {
        this.setState({ selectedCalendarPlugins: null, plugins: [] });
    }

    updatePlugin = (plugin) => {
        const newPlugins = this.state.plugins.map(p => p.plugin_name === plugin.plugin_name ? plugin : p);
        this.setState({ plugins: newPlugins });

        this.props.socketIO.socket.emit('calendars:updatePlugin', {
            calendarId: this.state.selectedCalendarPlugins.id,
            pluginName: plugin.plugin_name,
            enabled: plugin.enabled,
            settings: plugin.settings
        }, (response) => {
            if (!response.success) {
                enqueueSnackbar("Chyba pri aktualizácii pluginu: " + (response.error || response.err || 'Neznáma chyba'), { variant: 'error' });
            }
        });
    }

    openSettings = (calendar) => {
        let settings = {};
        
        if (calendar.type === 'rafting') {
            settings = {
                price_1day_workday: 20,
                price_1day_weekend: 25,
                price_multiday_workday: 17,
                price_multiday_weekend: 18
            };
        } else if (calendar.type === 'accommodation' || calendar.type === 'camping') {
            settings = {
                price_person_adult: 5,
                price_person_child: 3,
                price_tent: 4,
                price_car: 3,
                price_caravan: 10,
                price_stay_day_adult: 3,
                price_stay_day_child: 2
            };
        }

        if (calendar.settings && typeof calendar.settings === 'object') {
            settings = { ...settings, ...calendar.settings };
        } else if (calendar.settings && typeof calendar.settings === 'string') {
            try {
                settings = { ...settings, ...JSON.parse(calendar.settings) };
            } catch (e) { }
        }

        this.setState({
            selectedCalendarSettings: calendar,
            pricingSettings: settings
        });
    }

    closeSettings = () => {
        this.setState({ selectedCalendarSettings: null });
    }

    saveSettings = () => {
        const { selectedCalendarSettings, pricingSettings } = this.state;
        if (!selectedCalendarSettings) return;

        let updatedSettings = {
            ...pricingSettings
        };

        if (selectedCalendarSettings.settings && typeof selectedCalendarSettings.settings === 'object') {
            updatedSettings = { ...selectedCalendarSettings.settings, ...updatedSettings };
        }

        const updatedCalendar = {
            ...selectedCalendarSettings,
            settings: updatedSettings
        };

        this.props.socketIO.socket.emit('calendars:update', updatedCalendar, (response) => {
            if (response.success) {
                this.setState({ selectedCalendarSettings: null });
                this.fetchCalendars();
                enqueueSnackbar("Nastavenia uložené", { variant: 'success' });
            } else {
                enqueueSnackbar("Chyba pri ukladaní nastavení: " + (response.error || response.err || 'Neznáma chyba'), { variant: 'error' });
            }
        });
    }

    handleClose = () => {
        this.props.app.functions.setShownComponent(null);
    }

    renderPluginSettings = (plugin) => {
        if (plugin.plugin_name === 'sms') {
            const events = plugin.settings.events || {};
            const availableHooks = [
                { id: 'reservation.created', label: 'Vytvorenie rezervácie' },
                { id: 'reservation.updated', label: 'Úprava rezervácie' },
                { id: 'reservation.deleted', label: 'Zmazanie rezervácie' },
                { id: 'reservation.reminder', label: 'Pripomienka rezervácie (Cron)' },
                { id: 'client.created', label: 'Vytvorenie klienta' },
                { id: 'client.updated', label: 'Úprava klienta' },
                { id: 'client.deleted', label: 'Zmazanie klienta' },
                { id: 'calendar.created', label: 'Vytvorenie kalendára' },
                { id: 'calendar.updated', label: 'Úprava kalendára' },
                { id: 'calendar.deleted', label: 'Zmazanie kalendára' },
                { id: 'payment.created', label: 'Prijatie platby' },
                { id: 'payment.updated', label: 'Úprava platby' },
                { id: 'payment.deleted', label: 'Zmazanie platby' },
                { id: 'user.updated', label: 'Úprava používateľa' },
                { id: 'user.deleted', label: 'Zmazanie používateľa' },
                { id: 'giftcard.redeemed', label: 'Uplatnenie darčekového poukazu' },
                { id: 'giftcard.balance_checked', label: 'Kontrola zostatku poukazu' },
            ];

            const raftingAttributes = [
                'start_place', 'end_place', 'kanoe_count', 'katamaran_count', 'vest_count',
                'paddle_count', 'barrel_count', 'kanoe_count_info_min', 'kanoe_count_info_max',
                'katamaran_count_info', 'equipment_note'
            ];
            const campingAttributes = [
                'type_of_stay', 'adults_count', 'children_count', 'tents_count',
                'start_place', 'end_place'
            ];

            const calendarType = this.state.selectedCalendarPlugins?.type || 'rafting';
            const currentAttributes = calendarType === 'camping' ? campingAttributes : raftingAttributes;
            const variableHelpers = currentAttributes.map(a => `{${a}}`).join(', ');

            const handleChange = (hookId, field, value) => {
                const newEvents = { ...events };
                if (!newEvents[hookId]) newEvents[hookId] = { enabled: false, template: '' };
                newEvents[hookId] = { ...newEvents[hookId], [field]: value };

                const newSettings = { ...plugin.settings, events: newEvents };
                this.updatePlugin({ ...plugin, settings: newSettings });
            };

            return (
                <div className="mt-4">
                    <h4 className="text-sm font-semibold text-gray-700 mb-2">Udalosti (Hooks):</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {availableHooks.map(hook => {
                            const hookConfig = events[hook.id] || { enabled: false, template: '' };
                            return (
                                <div key={hook.id} className="border border-gray-200 rounded-lg p-4 bg-gray-50/50 flex flex-col">
                                    <div className="flex items-center justify-between mb-2">
                                        <div className="text-sm font-medium text-gray-900 truncate pr-2" title={hook.label}>
                                            {hook.label}
                                        </div>
                                        <button
                                            onClick={() => handleChange(hook.id, 'enabled', !hookConfig.enabled)}
                                            className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors whitespace-nowrap ${hookConfig.enabled
                                                ? 'bg-green-100 text-green-800 hover:bg-green-200'
                                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                                }`}
                                        >
                                            {hookConfig.enabled ? "Aktívne" : "Neaktívne"}
                                        </button>
                                    </div>

                                    {hookConfig.enabled && (
                                        <div className="space-y-1 flex-1 flex flex-col">
                                            <textarea
                                                rows={3}
                                                className="w-full p-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors flex-1"
                                                placeholder="Text SMS správy..."
                                                value={hookConfig.template || ''}
                                                onChange={(e) => handleChange(hook.id, 'template', e.target.value)}
                                            />
                                            <p className="text-xs text-gray-500 mt-1 truncate">
                                                Premenné: {'{id}'}, {'{date}'}, {'{price}'}, {variableHelpers}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )
        }
        return <p className="text-gray-500 text-sm mt-2">Žiadne nastavenia pre tento plugin.</p>
    }

    render() {
        const { tab, calendars, users, selectedUser, userAccess, selectedCalendarPlugins, plugins, selectedCalendarSettings, pricingSettings } = this.state;
        const { socketIO, app } = this.props;

        if (!socketIO) return null;
        if (app.state.shownComponent !== 'admin') return null;

        const containerClasses = `fixed inset-0 z-50 bg-white flex flex-col animate-in slide-in-from-bottom duration-300`;

        return (
            <div className={containerClasses}>
                <div className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between shadow-sm flex-shrink-0 z-10">
                    <div className="flex items-center gap-3">
                        <button
                            onClick={this.handleClose}
                            className="p-2 hover:bg-gray-100 rounded-full text-gray-600 transition-colors"
                        >
                            <X className="w-6 h-6" />
                        </button>
                        <h2 className="text-xl font-semibold text-gray-800"> Administrácia </h2>
                    </div>
                </div>

                <div className="bg-white border-b border-gray-200 px-4">
                    <div className="flex gap-6">
                        <button onClick={() => this.setState({ tab: 0 })} className={`py-3 text-sm font-medium border-b-2 transition-colors ${tab === 0 ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}> Kalendáre </button>
                        <button onClick={() => this.setState({ tab: 1 })} className={`py-3 text-sm font-medium border-b-2 transition-colors ${tab === 1 ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}> Používatelia </button>
                        <button onClick={() => { this.handleClose(); window.location.href = "/admin/clients"; }} className={`py-3 text-sm font-medium border-b-2 border-transparent text-gray-500 hover:text-gray-700 transition-colors flex items-center gap-1`}> <Users className="w-4 h-4" /> Klienti </button>
                    </div>
                </div>

                <div className="flex-1 overflow-y-auto bg-gray-50 p-6">
                    <div className="max-w-5xl mx-auto">
                        {tab === 0 && (
                            <div className="space-y-6">
                                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                                    <h3 className="text-lg font-semibold text-gray-800 mb-4">Pridať kalendár</h3>
                                    <div className="flex flex-wrap gap-4 items-end">
                                        <div className="flex-1 min-w-[200px]">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Názov</label>
                                            <input type="text" value={this.state.newCalendarName} onChange={(e) => this.setState({ newCalendarName: e.target.value })} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" />
                                        </div>
                                        <div className="w-40">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Typ</label>
                                            <select value={this.state.newCalendarType} onChange={(e) => this.setState({ newCalendarType: e.target.value })} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none bg-white">
                                                <option value="rafting">Rafting</option>
                                                <option value="accommodation">Táborisko</option>
                                            </select>
                                        </div>
                                        <button onClick={this.createCalendar} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors flex items-center gap-2"> <Plus className="w-5 h-5" /> Vytvoriť </button>
                                    </div>
                                </div>

                                <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                                    <ul className="divide-y divide-gray-200">
                                        {Array.isArray(calendars) && calendars.map(cal => (
                                            <li key={cal.id} className="p-4 hover:bg-gray-50 transition-colors flex items-center justify-between">
                                                <div>
                                                    <div className="font-medium text-gray-900">{cal.name}</div>
                                                    <div className="text-sm text-gray-500">ID: {cal.id} • Typ: {cal.type}</div>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    {(cal.type === 'rafting' || cal.type === 'accommodation' || cal.type === 'camping') && (
                                                        <button onClick={() => this.openSettings(cal)} className="px-3 py-1.5 border border-gray-300 hover:bg-gray-50 text-gray-700 rounded-lg text-sm font-medium transition-colors flex items-center gap-2"> <DollarSign className="w-4 h-4" /> Ceny </button>
                                                    )}
                                                    <button onClick={() => { this.handleClose(); window.location.href = `/admin/calendar/${cal.id}/plugins`; }} className="px-3 py-1.5 border border-gray-300 hover:bg-gray-50 text-gray-700 rounded-lg text-sm font-medium transition-colors flex items-center gap-2"> <Settings className="w-4 h-4" /> Pluginy </button>
                                                    <button onClick={() => this.deleteCalendar(cal.id)} className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"> <Trash2 className="w-5 h-5" /> </button>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        )}

                        {tab === 1 && (
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                <div className="md:col-span-1 bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden h-[calc(100vh-200px)] flex flex-col">
                                    <div className="p-4 border-b border-gray-200 flex justify-between items-center bg-gray-50">
                                        <div className="font-semibold text-gray-800">Používatelia</div>
                                        <button onClick={() => this.setState({ selectedUser: null, isCreatingUser: true })} className="p-1.5 bg-blue-100 text-blue-700 hover:bg-blue-200 rounded-lg transition-colors"> <Plus className="w-4 h-4" /> </button>
                                    </div>
                                    <div className="overflow-y-auto flex-1 p-2">
                                        <ul className="space-y-1">
                                            {Array.isArray(users) && users.map(u => (
                                                <li key={u.id}>
                                                    <button onClick={() => this.selectUser(u)} className={`w-full text-left p-3 rounded-lg transition-colors ${selectedUser?.id === u.id ? 'bg-blue-50 text-blue-700 border border-blue-100' : 'hover:bg-gray-100 text-gray-700 border border-transparent'}`}> <div className="font-medium">{u.name}</div> <div className="text-xs opacity-75 truncate">{u.email}</div> </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>

                                <div className="md:col-span-2 space-y-6">
                                    {this.state.isCreatingUser ? (
                                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 animate-in fade-in slide-in-from-right-4 duration-300">
                                            <div className="flex justify-between items-center mb-6">
                                                <h3 className="text-lg font-semibold text-gray-800">Nový používateľ</h3>
                                                <button onClick={() => this.setState({ isCreatingUser: false })} className="text-gray-400 hover:text-gray-600"> <X className="w-5 h-5" /> </button>
                                            </div>
                                            <div className="space-y-4 max-w-md">
                                                <div> <label className="block text-sm font-medium text-gray-700 mb-1">Meno</label> <input type="text" value={this.state.newUser?.name || ''} onChange={e => this.setState({ newUser: { ...this.state.newUser, name: e.target.value } })} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" /> </div>
                                                <div> <label className="block text-sm font-medium text-gray-700 mb-1">Skratka (iniciály)</label> <input type="text" value={this.state.newUser?.short_name || ''} onChange={e => this.setState({ newUser: { ...this.state.newUser, short_name: e.target.value } })} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" /> </div>
                                                <div> <label className="block text-sm font-medium text-gray-700 mb-1">Email</label> <input type="email" value={this.state.newUser?.email || ''} onChange={e => this.setState({ newUser: { ...this.state.newUser, email: e.target.value } })} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" /> </div>
                                                <div> <label className="block text-sm font-medium text-gray-700 mb-1">Heslo</label> <input type="password" value={this.state.newUser?.password || ''} onChange={e => this.setState({ newUser: { ...this.state.newUser, password: e.target.value } })} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" /> </div>
                                                <div className="pt-4"> <button onClick={this.createUser} className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"> Vytvoriť používateľa </button> </div>
                                            </div>
                                        </div>
                                    ) : selectedUser ? (
                                        <div className="space-y-6">
                                            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                                                <div className="flex justify-between items-start mb-6">
                                                    <h3 className="text-lg font-semibold text-gray-800"> Prístupy: <span className="text-blue-600">{selectedUser.name}</span> </h3>
                                                    {selectedUser.id !== 1 && (
                                                        <button onClick={() => this.deleteUser(selectedUser.id)} className="text-red-500 hover:text-red-700 p-2 hover:bg-red-50 rounded-lg transition-colors flex items-center gap-2 text-sm"> <Trash2 className="w-4 h-4" /> Zmazať používateľa </button>
                                                    )}
                                                </div>
                                                <div className="flex gap-4 items-end mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
                                                    <div className="flex-1"> <label className="block text-sm font-medium text-gray-700 mb-1">Priradiť kalendár</label> <select value={this.state.assignCalendarId} onChange={(e) => this.setState({ assignCalendarId: e.target.value })} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none bg-white"> <option value="">Vybrať kalendár...</option> {Array.isArray(calendars) && calendars.map(cal => ( <option key={cal.id} value={cal.id}>{cal.name}</option> ))} </select> </div>
                                                    <button onClick={this.grantAccess} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"> Pridať prístup </button>
                                                </div>
                                                <div className="space-y-3">
                                                    <h4 className="font-medium text-gray-700">Aktuálne prístupy</h4>
                                                    {Array.isArray(userAccess) && userAccess.length > 0 ? (
                                                        <ul className="divide-y divide-gray-200 border border-gray-200 rounded-lg overflow-hidden"> {userAccess.map(access => ( <li key={access.calendarId} className="p-3 bg-white flex items-center justify-between"> <div> <div className="font-medium text-gray-900">Kalendár ID: {access.calendarId} ({access.calendarName})</div> <div className="text-sm text-gray-500">Rola: {access.role}</div> </div> <button onClick={() => this.revokeAccess(access.calendarId)} className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"> <Trash2 className="w-5 h-5" /> </button> </li> ))} </ul>
                                                    ) : ( <div className="text-center py-8 text-gray-500 bg-gray-50 rounded-lg border border-dashed border-gray-300"> Žiadne prístupy </div> )}
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="h-full flex items-center justify-center text-gray-400 bg-gray-50 rounded-xl border border-dashed border-gray-300 p-12 flex-col gap-2"> <Users className="w-12 h-12 opacity-20" /> <span>Vyberte používateľa zo zoznamu alebo vytvorte nového</span> </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {selectedCalendarPlugins && (
                    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
                        <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl flex flex-col overflow-hidden animate-in fade-in zoom-in duration-200" style={{ maxHeight: '80vh' }}>
                            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between flex-shrink-0"> <h3 className="text-xl font-semibold text-gray-800"> Pluginy pre: {selectedCalendarPlugins.name} </h3> <button onClick={this.closePlugins} className="p-2 hover:bg-gray-100 rounded-full text-gray-600 transition-colors"> <X className="w-6 h-6" /> </button> </div>
                            <div className="flex-1 overflow-y-auto p-4 sm:p-6 bg-gray-50 min-h-0"> {Array.isArray(plugins) && plugins.map(plugin => ( <div key={plugin.plugin_name} className="bg-white rounded-lg border border-gray-200 p-6 mb-4 shadow-sm"> <div className="flex items-center justify-between mb-4"> <h4 className="text-lg font-bold text-gray-900">{plugin.plugin_name.toUpperCase()}</h4> <button onClick={() => this.updatePlugin({ ...plugin, enabled: !plugin.enabled })} className={`px-4 py-2 rounded-lg font-medium transition-colors ${plugin.enabled ? 'bg-green-600 hover:bg-green-700 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-700' }`}> {plugin.enabled ? "Zapnuté" : "Vypnuté"} </button> </div> {plugin.enabled && this.renderPluginSettings(plugin)} </div> ))} </div>
                        </div>
                    </div>
                )}

                {selectedCalendarSettings && (
                    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
                        <div className="bg-white rounded-xl shadow-xl w-full max-w-md flex flex-col overflow-hidden animate-in fade-in zoom-in duration-200" style={{ maxHeight: '80vh' }}>
                            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between"> <h3 className="text-xl font-semibold text-gray-800"> Nastavenia cien </h3> <button onClick={this.closeSettings} className="p-2 hover:bg-gray-100 rounded-full text-gray-600 transition-colors"> <X className="w-6 h-6" /> </button> </div>
                            <div className="p-6 space-y-4 bg-gray-50 flex-1 overflow-y-auto min-h-0">
                                {selectedCalendarSettings.type === 'rafting' ? (
                                    <>
                                        <div className="space-y-4">
                                            <h4 className="text-sm font-bold text-gray-900 uppercase">Jednodňové splavy</h4>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div> <label className="block text-xs font-medium text-gray-600 mb-1">Po - Štv</label> <input type="number" value={pricingSettings.price_1day_workday} onChange={(e) => this.setState({ pricingSettings: { ...pricingSettings, price_1day_workday: parseInt(e.target.value) || 0 } })} className="w-full p-2 text-sm border border-gray-300 rounded-lg outline-none" /> </div>
                                                <div> <label className="block text-xs font-medium text-gray-600 mb-1">Pia - Ne + Sviatky</label> <input type="number" value={pricingSettings.price_1day_weekend} onChange={(e) => this.setState({ pricingSettings: { ...pricingSettings, price_1day_weekend: parseInt(e.target.value) || 0 } })} className="w-full p-2 text-sm border border-gray-300 rounded-lg outline-none" /> </div>
                                            </div>
                                        </div>
                                        <div className="space-y-4">
                                            <h4 className="text-sm font-bold text-gray-900 uppercase">Viacdňové splavy</h4>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div> <label className="block text-xs font-medium text-gray-600 mb-1">Po - Štv (deň)</label> <input type="number" value={pricingSettings.price_multiday_workday} onChange={(e) => this.setState({ pricingSettings: { ...pricingSettings, price_multiday_workday: parseInt(e.target.value) || 0 } })} className="w-full p-2 text-sm border border-gray-300 rounded-lg outline-none" /> </div>
                                                <div> <label className="block text-xs font-medium text-gray-600 mb-1">Pia - Ne + (deň)</label> <input type="number" value={pricingSettings.price_multiday_weekend} onChange={(e) => this.setState({ pricingSettings: { ...pricingSettings, price_multiday_weekend: parseInt(e.target.value) || 0 } })} className="w-full p-2 text-sm border border-gray-300 rounded-lg outline-none" /> </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="space-y-6">
                                        <div className="space-y-4">
                                            <h4 className="text-sm font-bold text-gray-900 uppercase border-b pb-2">Osoby (noc)</h4>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div> <label className="block text-xs font-medium text-gray-600 mb-1">Dospelý</label> <input type="number" value={pricingSettings.price_person_adult} onChange={(e) => this.setState({ pricingSettings: { ...pricingSettings, price_person_adult: parseInt(e.target.value) || 0 } })} className="w-full p-2 text-sm border border-gray-300 rounded-lg outline-none" /> </div>
                                                <div> <label className="block text-xs font-medium text-gray-600 mb-1">Dieťa</label> <input type="number" value={pricingSettings.price_person_child} onChange={(e) => this.setState({ pricingSettings: { ...pricingSettings, price_person_child: parseInt(e.target.value) || 0 } })} className="w-full p-2 text-sm border border-gray-300 rounded-lg outline-none" /> </div>
                                            </div>
                                        </div>
                                        <div className="space-y-4">
                                            <h4 className="text-sm font-bold text-gray-900 uppercase border-b pb-2">Vybavenie (noc)</h4>
                                            <div className="grid grid-cols-3 gap-4">
                                                <div> <label className="block text-xs font-medium text-gray-600 mb-1">Stan</label> <input type="number" value={pricingSettings.price_tent} onChange={(e) => this.setState({ pricingSettings: { ...pricingSettings, price_tent: parseInt(e.target.value) || 0 } })} className="w-full p-2 text-sm border border-gray-300 rounded-lg outline-none" /> </div>
                                                <div> <label className="block text-xs font-medium text-gray-600 mb-1">Auto</label> <input type="number" value={pricingSettings.price_car} onChange={(e) => this.setState({ pricingSettings: { ...pricingSettings, price_car: parseInt(e.target.value) || 0 } })} className="w-full p-2 text-sm border border-gray-300 rounded-lg outline-none" /> </div>
                                                <div> <label className="block text-xs font-medium text-gray-600 mb-1">Karavan</label> <input type="number" value={pricingSettings.price_caravan} onChange={(e) => this.setState({ pricingSettings: { ...pricingSettings, price_caravan: parseInt(e.target.value) || 0 } })} className="w-full p-2 text-sm border border-gray-300 rounded-lg outline-none" /> </div>
                                            </div>
                                        </div>
                                        <div className="space-y-4">
                                            <h4 className="text-sm font-bold text-gray-900 uppercase border-b pb-2">Denný pobyt</h4>
                                            <div className="grid grid-cols-2 gap-4">
                                                <div> <label className="block text-xs font-medium text-gray-600 mb-1">Dospelý / deň</label> <input type="number" value={pricingSettings.price_stay_day_adult} onChange={(e) => this.setState({ pricingSettings: { ...pricingSettings, price_stay_day_adult: parseInt(e.target.value) || 0 } })} className="w-full p-2 text-sm border border-gray-300 rounded-lg outline-none" /> </div>
                                                <div> <label className="block text-xs font-medium text-gray-600 mb-1">Dieťa / deň</label> <input type="number" value={pricingSettings.price_stay_day_child} onChange={(e) => this.setState({ pricingSettings: { ...pricingSettings, price_stay_day_child: parseInt(e.target.value) || 0 } })} className="w-full p-2 text-sm border border-gray-300 rounded-lg outline-none" /> </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="px-6 py-4 bg-white border-t border-gray-200 flex justify-end"> <button onClick={this.saveSettings} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"> Uložiť zmeny </button> </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default withAllContexts(AdminModal);
